import { Permission } from "@forgepoint/shared";
import Layout from "@/components/layout";
import AccessRestricted from "@/components/AccessRestricted";
import DatasetExplorerController from "@/modules/datasetExplorer/DatasetExplorerController";
import { useHasPermission } from "@/store/authStore";

/**
 * Dataset Explorer page — BI-like query builder for structured datasets.
 */
export default function DatasetExplorer() {
  const breadcrumbs = [{ label: "Dataset Explorer", current: true }];
  const canView = useHasPermission(Permission.DATASETS_VIEW_ALL);

  if (!canView) {
    return (
      <AccessRestricted
        breadcrumbs={breadcrumbs}
        message="You do not have access to the Dataset Explorer."
      />
    );
  }

  return (
    <Layout breadcrumbs={breadcrumbs}>
      <DatasetExplorerController />
    </Layout>
  );
}
